import { Component, inject, Input } from '@angular/core';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { CountBoxComponent } from '../../atoms/count-box/count-box.component';

@Component({
  selector: 'app-count-box-layer-type',
  standalone: true,
  imports: [CountBoxComponent],
  templateUrl: './count-box-layer-type.component.html',
  styleUrl: './count-box-layer-type.component.scss',
})
export class CountBoxLayerTypeComponent {
  readonly store = inject(DataLayerTypeStore);
  @Input() title = 'Räume';
  @Input() text = '';
  @Input() styleClass = '';
}
